import api from '@/services/api/api';

export const useAudioCategories = (
  params = {
    filters: {},
  },
) => {
  const audioRubrics = useQuery(
    ['audioRubrics', params.filters],
    async () => {
      const { data } = await api.lectures.getAudioLecturesCategories(
        toValue(params.filters),
      );
      return data;
    },
    {
      staleTime: Infinity,
      select: ({ data }) => data,
    },
  );

  onServerPrefetch(async () => {
    await audioRubrics.suspense();
  });

  return {
    audioRubrics,
  };
};
